import React from "react";
import { useDispatch } from "react-redux";
import { updateNavbarHeading } from "../../../constants/layout/store/filterSlice";
import { useState, useEffect } from "react";
import FormTable from "../../../components/TabelPRScore";
import Select from "react-select";
import { API_URL } from "../../../constants";
import { GetServiceCaller } from "../../../services/serviceCaller";

const PRScoreReport = () => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(updateNavbarHeading("PR Score Report"));
  }, []);
  const [reportList, setReplortList] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [appraisalOpts, setAppraisalOpts] = useState([]);
  const [employee, setEmployee] = useState([]);
  let filters = {
    apprisalCycle: 0,
    employee: 0,
  };
  const [filter, setFilter] = useState(filters);
  useEffect(() => {
    fetchReportList();
  }, [searchTerm]);
  const fetchReportList = async () => {
    try {
      const response = await GetServiceCaller(
        `${API_URL}pr-report/4?P_AppraisalCycleID=${filter.apprisalCycle}&P_EmployeeID=${filter.employee}`
      );
      setReplortList(response.data.header);
      const Appraisalopts = response.data.appraisalCycle.map((tech) => ({
        value: tech.value,
        label: tech.text,
      }));
      Appraisalopts.unshift({ value: 0, label: "Select..." });
      setAppraisalOpts(Appraisalopts);
      const employeeopts = response.data.employeeList.map((tech) => ({
        value: tech.value,
        label: tech.text,
      }));
      employeeopts.unshift({ value: 0, label: "Select..." });
      setEmployee(employeeopts);
    } catch (error) {
      console.error("Error fetching reports", error);
    }
  };

  const handleDropdownChange = (selected) => {
    setFilter({ ...filter, apprisalCycle: selected.value });
  };

  const handleDropdownChange1 = (selected) => {
    setFilter({ ...filter, employee: selected.value });
  };
  const HandleFilter = async () => {
    try {
      const response = await GetServiceCaller(
        `${API_URL}pr-report/4?P_AppraisalCycleID=${filter.apprisalCycle}&P_EmployeeID=${filter.employee}`
      );
      setReplortList(response.data.header);
    } catch (error) {
      console.error("Error fetching job:", error);
    }
  };
  return (
    <>
      <div className="container-fluid" id="skill_section">
        <div className="container-fluid" id="skill-table-area">
          <div className="row mt-3 mr-3 ">
            <div className="col-md-3 ">
              <div className="row mb-3">
                <label
                  htmlFor="refercandidatelist"
                  className="col-md-4 form-label mt-1 text-center"
                >
                  Appraisal Cycle
                </label>
                <div className="col-md-8">
                  <Select
                    name="apprasisalCycle"
                    onChange={handleDropdownChange}
                    options={appraisalOpts}
                    placeholder="Select..."
                  />
                </div>
              </div>
            </div>

            <div className="col-md-3 ">
              <div className="row mb-3">
                <label
                  htmlFor="refercandidatelist"
                  className="col-md-4 form-label mt-1 text-center"
                >
                  Employee
                </label>
                <div className="col-md-8">
                  <Select
                    name="employee"
                    onChange={handleDropdownChange1}
                    options={employee}
                    placeholder="Select..."
                  />
                </div>
              </div>
            </div>
            <div className="col-md-3 "></div>
            <div className="col-md-3 ">
              <div className="text-end mb-3 offset-1 me-4">
                <div className="justify-content-center">
                  <button className="custom-btn" onClick={HandleFilter}>
                    Get Data
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className="box-body table-responsive">
            <FormTable
              data={reportList}
              columns={""}
              defaultColumns={""}
              itemsPerPage={10}
              searchTerm={searchTerm}
              setSearchTerm={setSearchTerm}
              // path need to be send from here
              // Path={./demo}
              // to be check path in component
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default PRScoreReport;
